var STATES = {
    CLOSED: 'closed',
    OPEN: 'open'
};
var Column = /** @class */ (function () {
    function Column($el) {
        this.$el = $el;
        this.el = $el[0];
        this.settings = [];
        this.state = STATES.CLOSED;
        this._type = this.$el.data('type');
    }
    Object.defineProperty(Column.prototype, "name", {
        get: function () {
            return this.$el.data('column-name');
        },
        set: function (name) {
            this.$el.data('column-name', name);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (type) {
            this.$el.data('type', type);
        },
        enumerable: false,
        configurable: true
    });
    Column.prototype.isOriginal = function () {
        return (1 === this.$el.data('original'));
    };
    Column.prototype.isDisabled = function () {
        return this.$el.hasClass('disabled');
    };
    Column.prototype.disable = function () {
        this.$el.addClass('disabled');
        return this;
    };
    Column.prototype.enable = function () {
        this.$el.removeClass('disabled');
        return this;
    };
    Column.prototype.initNewInstance = function () {
        var temp_column_name = '_new_column_' + AC.Column.getNewIncementalName();
        var original_column_name = this.name;
        this.$el.find('input, select, label').each(function (i, v) {
            var $input = jQuery(v);
            // name attributes
            if ($input.attr('name')) {
                $input.attr('name', $input.attr('name').replace("columns[" + original_column_name + "]", "columns[" + temp_column_name + "]"));
            }
            // id attributes
            if ($input.attr('id')) {
                $input.attr('id', $input.attr('id').replace("-" + original_column_name + "-", "-" + temp_column_name + "-"));
            }
        });
        this.name = temp_column_name;
        AC.incremental_column_name++;
        return this;
    };
    /**
     *
     * @returns {Column}
     */
    Column.prototype.bindEvents = function () {
        var column = this;
        column.$el.data('column', column);
        Object.keys(AC.Column.events).forEach(function (key) {
            if (!column.isBound(key)) {
                AC.Column.events[key](column);
                column.bind(key);
            }
        });
        this.bindSettings();
        jQuery(document).trigger('AC_Column_InitSettings', [column]);
        return this;
    };
    Column.prototype.bindSettings = function () {
        var column = this;
        Object.keys(AC.Column.settings).forEach(function (key) {
            if (!column.isBound(key)) {
                AC.Column.settings[key](column);
                column.bind(key);
            }
        });
    };
    /**
     *
     * @param key
     * @returns {bool}
     */
    Column.prototype.isBound = function (key) {
        return this.$el.data(key);
    };
    Column.prototype.bind = function (key) {
        this.$el.data(key, true);
    };
    Column.prototype.destroy = function () {
        this.$el.remove();
    };
    Column.prototype.remove = function (duration) {
        if (duration === void 0) { duration = 350; }
        var self = this;
        this.$el.addClass('deleting').animate({ opacity: 0, height: 0 }, duration, function () {
            self.destroy();
        });
    };
    Column.prototype.getState = function () {
        return this.state;
    };
    Column.prototype.toggle = function (duration) {
        if (duration === void 0) { duration = 150; }
        if (this.getState() === STATES.OPEN) {
            this.close(duration);
        }
        else {
            this.open(duration);
        }
    };
    Column.prototype.close = function (duration) {
        if (duration === void 0) { duration = 0; }
        this.$el.removeClass('opened').find('.ac-column-body').slideUp(duration);
        this.state = STATES.CLOSED;
    };
    Column.prototype.open = function (duration) {
        if (duration === void 0) { duration = 0; }
        this.$el.addClass('opened').find('.ac-column-body').slideDown(duration);
        this.state = STATES.OPEN;
    };
    Column.prototype.showMessage = function (message) {
        this.$el.find('.ac-column-setting--type .msg').html(message).show();
    };
    Column.prototype.switchToType = function (type) {
        var self = this;
        return jQuery.ajax({
            url: ajaxurl,
            method: 'post',
            dataType: 'json',
            data: {
                action: 'ac-columns',
                id: 'select',
                type: type,
                data: AdminColumns.Form.serialize(),
                current_original_columns: AdminColumns.Form.originalColumns(),
                original_columns: AC.original_columns,
                _ajax_nonce: AC._ajax_nonce,
            },
            success: function (response) {
                if (true === response.success) {
                    var column = jQuery(response.data);
                    self.$el.replaceWith(column);
                    self.$el = column;
                    self.el = column[0];
                    self._type = type;
                    self.initNewInstance();
                    self.bindEvents();
                    self.open();
                    jQuery(document).trigger('AC_Column_Change', [self]);
                }
                else {
                    self.showMessage(response.data.error);
                }
            }
        });
    };
    Column.prototype.refresh = function () {
        var self = this;
        var data = this.$el.find(':input').serializeArray();
        var request_data = {
            action: 'ac-columns',
            id: 'refresh',
            _ajax_nonce: AC._ajax_nonce,
            data: AdminColumns.Form.serialize(),
            column_name: this.name,
            original_columns: AC.original_columns
        };
        jQuery.each(request_data, function (name, value) {
            data.push({
                name: name,
                value: value
            });
        });
        return jQuery.ajax({
            type: 'post',
            url: ajaxurl,
            data: data,
            success: function (response) {
                if (true === response.success) {
                    var column = jQuery(response.data);
                    self.$el.replaceWith(column);
                    self.$el = column;
                    self.el = column[0];
                    self.bindEvents();
                    if (self.getState() === STATES.OPEN) {
                        self.open();
                    }
                    jQuery(document).trigger('AC_Column_Refresh', [self]);
                }
            }
        });
    };
    /**
     * @returns {Column}
     */
    Column.prototype.create = function () {
        this.initNewInstance();
        this.bindEvents();
        jQuery(document).trigger('AC_Column_Created', [this]);
        return this;
    };
    /**
     * @returns {Column}
     */
    Column.prototype.clone = function () {
        var $clone = this.$el.clone();
        $clone.data('column-name', this.$el.data('column-name'));
        var clone = new Column($clone);
        clone.initNewInstance();
        clone.bindEvents();
        return clone;
    };
    return Column;
}());
export default Column;
